import { db } from '@react-native-firebase/database';
import storage from '@react-native-firebase/storage';
import StyleSheetRW from 'core/StyleSheetRW';
import { push, ref, set } from "firebase/database";
import React, { useRef, useState } from 'react';
import { BsFillCloudUploadFill } from 'react-icons/bs';
import { TouchableOpacity } from 'react-native';
import { Dimensions, ScrollView, Text, TextInput, View } from 'react-native';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
import DateField from 'src/components/DateField';
import Dialog from 'src/components/Dialog';
import closeIcon from "res/img/cross.png";

import Loader from 'src/components/Loader';
import { textFieldFilteration, validateEmail } from 'src/utils/TextFieldUtils';
interface AddCandidateFormProps {
  openForm: boolean
  editMode:boolean
  handleFormClose(): void
  handleFormSubmit():void
  candidates: any
}
export const AddCandidateForm = ({ openForm, handleFormClose,handleFormSubmit, candidates,editMode }: AddCandidateFormProps) => {
  const fileInputRef = useRef(null);
  const [showLoader, setShowLoader] = useState(false)
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const handleEditFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setShowLoader(true)
    try {

        console.log('New Form',formData)
        const dbRef = ref(db, `recruitment/${formData.id}`);
        const data = {
            name: formData.name,
            email: formData.email,
            fileUrl:formData.fileUrl,
            fileName: formData.fileName,
          };
          if (formData.currentSalary) {
            data.currentSalary = formData.currentSalary;
          }
          if (formData.expectedSalary) {
            data.expectedSalary = formData.expectedSalary;
          }
          if (formData.availability){
            data.availability = formData.availability;
          } 
          if (formData.otherDetails) {
            data.otherDetails = formData.otherDetails;
          }
          if(formData.experience){
            data.experience=formData.experience;
          } 
        await set(dbRef, formData)
          .then(() => {
            setShowLoader(false)
            setShowToast(true);
            setToastMessage("Candidate Updated Successfully!");
          })
          .catch((error) => {
            setShowLoader(false)
            console.error("Error Editing Candidate:", error);
            setShowToast(true);
            setToastMessage(`Error Updating Candidate: ${error}`);
          });
     
    } catch (error) {
      setShowLoader(false)
      setShowToast(true)
      setToastMessage('Form Submission Failed!')
    }
  };
  const handleFileInputClick = () => {
    fileInputRef.current.click();
  };
  const initialFormData = {
    name: "",
    email: "",
    currentSalary: "",
    expectedSalary: "",
    experience: 0,
    availability: "",
    otherDetails: "",
    file: null,
  };

  const initialEditFormData=
  {
    id:candidates.id,
    name: candidates.name,
    email:candidates.email,
    currentSalary: candidates.currentSalary||0,
    expectedSalary: candidates.expectedSalary||0,
    experience:  candidates.experience||0,
    availability:  candidates.availability||'',
    otherDetails:candidates.otherDetails||'',
    fileUrl: candidates.fileUrl||'',
    fileName: candidates.fileName||''
  }

  const screenWidth = Dimensions.get('window').width;
  const [formData, setFormData] = useState(editMode?initialEditFormData:initialFormData);
  const [isVisible, setIsVisible] = useState(openForm)
  const handleChangeTextType = (name: string, value: any, textType?: string) => {
    let filteredValue
    if(textType){
     filteredValue = textType === 'file' ? value : textFieldFilteration(value, textType);

    }else{
       filteredValue = value 
    }
    setFormData({ ...formData, [name]: filteredValue });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleChangeTextType('file', file, 'file');
    }
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setShowLoader(true)
    if (!formData.file || !formData.email || !formData.name) {
      setShowLoader(false)
      setShowToast(true)
      setToastMessage('Please Fill the Necessary Fields')
      return;
    }

    if (validateEmail(formData.email) === false) {
      setShowLoader(false)
      setShowToast(true)
      setToastMessage('Incorrect Email Format Used')
      return;
    }

    try {
      const emailExists = candidates.some((candidate) => candidate.email === formData.email);
      if (emailExists) {
        setShowLoader(false)
        setShowToast(true)
        setToastMessage('User with this email already exists')
        return;
      }

      const storageRef = storage().ref(`resumes/${formData.email}`);
      await storageRef.putFile(formData.file);
      const fileUrl = await storageRef.getDownloadURL();
      const newRef = push(ref(db, 'recruitment'));
      const data = {
        name: formData.name,
        email: formData.email,
        fileUrl,
        fileName: formData.file.name,
      };
      if (formData.currentSalary) {
        data.currentSalary = formData.currentSalary;
      }
      if (formData.expectedSalary) {
        data.expectedSalary = formData.expectedSalary;
      }
      if (formData.availability){
        data.availability = formData.availability;
      } 
      if (formData.otherDetails) {
        data.otherDetails = formData.otherDetails;
      }
      if(formData.experience){
        data.experience=formData.experience;
      } 
      await set(newRef, data);
      setShowLoader(false)
      setFormData({ ...initialFormData, availability: '' });
      setShowToast(true)
      setToastMessage('Candidate Entered Successfully!')
    } catch (error) {
      setShowLoader(false)
      setShowToast(true)
      setToastMessage('Form Submission Failed!')
    }
  };

  return (
    <>
      <Dialog
        message={toastMessage}
        isDialogVisible={showToast}
        onDialogClose={() => {
          setShowToast(false)
          if(toastMessage.includes('Candidate Entered Successfully!')||toastMessage.includes('Candidate Updated Successfully!'))
        { handleFormSubmit()}
        }
        }
        title="Add Candidate"
        confirmText="Close"
      />
      {
        showLoader && <Loader />
      }
      {isVisible && <View style={{ position: "absolute", zIndex: 1, top: 0, left: 0, right: 0, bottom: 0, justifyContent: "center", alignItems: "center", overflow: "hidden", }}>
        <View style={{ flex: 1, width: "100%", height: "100%" }}>
          <View style={{ ...styles.Container, paddingTop: screenWidth <= MOBILE_VIEW_WIDTH ? "10px" : "20px", height: "550px" }}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Text style={styles.heading}>{editMode?'Edit Candidate':'Add Candidate'}</Text>
           
              <img src={closeIcon} alt="Close"    style={{ right: 10, position: "absolute", top: 5, cursor: "pointer", width:13,height:13 }}  onClick={handleFormClose}/>

            </View>
          <ScrollView showsVerticalScrollIndicator={false} >

            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Name*</Text>
              <TextInput
                style={styles.input}
                placeholder="Name"
                editable={!editMode}
                value={formData.name}
                onChangeText={(text) => handleChangeTextType("name", text)}
              />
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Email*</Text>
              <TextInput
                style={styles.input}
                placeholder="Email"
                editable={!editMode}
                value={formData.email}
                onChangeText={(text) => { handleChangeTextType('email', text, 'email') }}
              />
            </View>
            <View style={{ ...styles.container2 }}>
              <Text style={[styles.label, { marginTop: 0 }]}>Resume*</Text>
              <div
                style={{ display: 'flex',flexDirection:'row',alignItems:'center',gap:5, cursor: 'pointer', marginTop: '10px' }}
                onClick={!editMode?handleFileInputClick:undefined}
              >
                <BsFillCloudUploadFill style={{ width: 24, height: 24 }} />
           {!editMode &&  <Text>{formData.file?formData.file.name:''}</Text>}
           {editMode &&  <Text>{formData.fileName}</Text>}
              </div>
              <input
  type="file"
  ref={fileInputRef}
  style={{ display: 'none' }}
  accept=".doc,.docx,.pdf"
  onChange={handleFileChange}
/>

            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Current Salary</Text>
              <TextInput
                style={styles.input}
                placeholder="Current Salary"
                value={formData.currentSalary||''}
                onChangeText={(text) => { handleChangeTextType('currentSalary', text, 'number') }}
              />
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Expected Salary</Text>
              <TextInput
                style={styles.input}
                placeholder="Expected Salary"
                value={formData.expectedSalary||''}
                onChangeText={(text) => { handleChangeTextType('expectedSalary', text, 'number') }}
              />
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Experience</Text>
              <TextInput
                style={styles.input}
                placeholder="Experience"
                value={formData.experience||''}
                onChangeText={(text) => { handleChangeTextType('experience', text, 'number') }}
              />
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Availability</Text>
              <DateField
                value={formData.availability}
                placeholder="yyyy-MM-dd"
                onChangeText={(text) => { handleChangeTextType('availability', text, 'date') }}
                label=''
              />
            </View>
            <View style={{ ...styles.container2, marginTop: -2 }}>
              <Text style={[styles.label, { marginTop: 0 }]}>Other Details</Text>
              <TextInput
                style={styles.input}
                placeholder="Other Details"
                value={formData.otherDetails}
                onChangeText={(text) => { handleChangeTextType('otherDetails', text, 'alphanumericWithSpecialChars') }}
              />
            </View>
            <View style={{flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
            <TouchableOpacity
              style={{ marginTop:20,backgroundColor: '#2F4858',width:147, borderRadius: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingVertical: 10 }}
              onPress={editMode?handleEditFormSubmit:handleSubmit}
            >
              <Text style={{ color: 'white', cursor: "pointer" }}>Save</Text>
            </TouchableOpacity>
            </View>
          </ScrollView>
          </View>
        </View>
      </View>}
    </>
  );
};

const styles = StyleSheetRW.create(() => ({
  container2: { display: "flex", flexDirection: "column", marginTop: 18 },
  Container: {
    position: "absolute",
    top: "10px",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    opacity: 1,
    transition: "opacity 0.3s ease",
    zIndex: 1,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    width: "299px",
    alignSelf: "center",
  },
  heading: {
    fontFamily: "Outfit",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    color: "#333333",
  },
  label: {
    fontFamily: "Outfit",
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 17.64,
    textAlign: "left",
    width: "100%",
    marginTop: 10,
    marginBottom: 5,
    color: "#333333",
  },
  input: {
    height: 50,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: "#0000000D",
    marginTop: 3,
  },
  button: {
    backgroundColor: "#2F4858",
    alignSelf: "center",
    borderRadius: 100,
    color: "white",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    width: "250px",
    height: "38px",
    cursor: "pointer",
  },
  buttoneStyle: {
    backgroundColor: "#8c9ea2",
    borderRadius: 99,
    fontWeight: "lighter",
    fontSize: "14px",
    color: "white",
    width: "110px",
    height: "37px",
    border: "0",
    cursor: "pointer",
  },
}));
